import { render } from "./DateOrTimeField.vue?vue&type=template&id=08b1ffa6&scoped=true"
import script from "./DateOrTimeField.vue?vue&type=script&lang=ts"
export * from "./DateOrTimeField.vue?vue&type=script&lang=ts"

import "./DateOrTimeField.vue?vue&type=style&index=0&id=08b1ffa6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-08b1ffa6"

export default script